module.exports = __webpack_public_path__ + "img/bg.47ff9ff0.gif";